<template> 
  <div class="publicPadding16"> 
     <div class="publicRow publicBetween">
       <div class="linShiWidth publicColumn" v-for="(item,index) in list" :key="index" @click="toDetails(item)">
          <img v-if="item.icon" :src="Global + item.icon" style="width:100%;height:115px;border-radius: 10px" />
          <img v-if="!item.icon" src="@/assets/image/noshowPic.png" style="width:100%;height:115px;border-radius: 10px;background:red;border: solid 1px black;" />
          <div class="titleName1s">{{item.title}}</div>
       </div>
    </div>
  </div>
</template>

<script>
// import { getAboutSpotList } from "@/api/common";
import { getMenuOpenList } from "@/api/publicApi";
import  {addHits}  from "@/util/publicHits";
export default {
  name: 'AppPageTwo',
  props: { 
  },
  computed: { 
  },
  data() {
    return { 
      publicIconUrl: 'http://gw.wyschina.com/',
      list:[ 
      ]
    };
  },
  created(){
    //
  },
  mounted() { 
    //
    this.initData()
  },
  methods: { 
    async initData(){
      //景区风景 
      // const { code, data } = await getAboutSpotList();
      // this.current, this.pageSize
      const { code, data } = await getMenuOpenList( 0,'about_spot',1,168 );
      if (code == 200) {
        this.list = data.records 
      } 
    },
    toDetails(item){ 
      addHits(item.id);
      this.$router.push({ path: "/newInfoDetail", query: { "item":item } }); 
    }
  }
  
}
</script>

<style scoped>
.main {
  max-width: 1920px;
  margin: auto;
}
.linShiWidth{
  width: calc(50vw - 24px);
  height:150px;
  margin-bottom:16px;
}
.titleName1s{
  height:35px;
  line-height:35px;
  color:#071420;
  font-size:14px;
  font-family: SourceHanSansCN-Regular;
  /* margin-top: 16px; */
  font-weight: 500;
  overflow: hidden;
}
</style>




// WEBPACK FOOTER //
// src/views/app/appPageTwo.vue